import * as React from 'react';
const Monitor = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 22 20"
		fill="none"
		{...props}
	>
		<path
			stroke="#fff"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="M3 7h4m6.75-5 1 2H17M3 11.5a4 4 0 1 0 4 0V3a2 2 0 1 0-4 0v8.5Z"
		/>
		<path
			stroke="#fff"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="m16 2-3 5 2 3m4.25-2L18 10l1.25 2"
		/>
		<path
			stroke="#fff"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="M21 10h-6l-2 3m4 3h-2.25l-1 2"
		/>
		<path
			stroke="#fff"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="m16 18-3-5h-1m-1-6 2.088.008"
		/>
	</svg>
);
export default Monitor;
